module.exports = __webpack_public_path__ + "img/banner-nl-mobile.e187cff9.jpg";